import $ from "jquery";

$(function() {
  var trigger = $(".l-nav__item--hamburger > a");
  var nav = $(".l-nav");

  trigger.on("click", function() {
    $("body").toggleClass("show-nav");
  });

  // reset menu on resize
  $(window).resize(function() {
    $("body").removeClass("show-nav");
  });

  function clickout(e) {
    if (!$(nav).is(e.target) && $(nav).has(e.target).length === 0) {
      $("body").removeClass("show-nav");
    }
  }

  $("html body").mousedown(function(e) {
    clickout(e);
  });
});
